<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.pending_review_funds") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col
                .d-inline-block
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t('ui.refresh') }}
                    b-input-group-text(slot="append")
                      label.custom-switch
                        input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="$options.refreshOn" @change="toggleRefresh()")
                        span.custom-switch-indicator
                    b-input-group-text(slot="append")
                      b-input(v-model="refreshInterval" type="range" min="1" max="5")
                    b-input-group-text(slot="append")
                      span {{ refreshInterval }} s
                .d-inline-block.align-top.ml-2
                  b-input-group(size="sm").mb-1
                    b-input-group-text(slot="prepend")
                      span {{ $t('ui.alert') }}
                    b-input-group-text(slot="append")
                      label.custom-switch
                        input.custom-switch-input(type="checkbox" v-model="alert")
                        span.custom-switch-indicator

              .form-group.col-12
                .row
                  .col-4
                    .form-group
                      b-input-group(size="sm")
                        b-form-select.col-4(v-model="searchType" size="sm" @input="resetInput()")
                          option(value="operator" v-if="!isOperator") {{ $t('ui.operator') }}
                          option(value="member" v-else-if="isOperator") {{ $t('ui.member') }}
                          option(value="ticket") {{ $t('ui.ticket') }}
                        template(v-if="['operator'].includes(searchType)")
                          DebounceInput(autofocus type="text" v-model="operatorID" :placeholder="$t('message.search_by_' + searchType)" @enter="getTicketList()" size="sm")
                        template(v-else-if="['member'].includes(searchType)")
                          DebounceInput(autofocus type="text" v-model="memberID" :placeholder="$t('ui.member')" @enter="getTicketList()" size="sm")
                        template(v-if="['ticket'].includes(searchType)")
                          DebounceInput(autofocus type="text" v-model="ticketId" :placeholder="$t('message.search_by_' + searchType)" @enter="getTicketList()" size="sm")
                  .col-6
                    template(v-if="['operator'].includes(searchType)")
                      template(v-if="operatorID != ''")
                        .form-group.col-6
                          b-input-group(size="sm")
                            b-input-group-text(slot="prepend")
                              i.fa.fa-search
                            DebounceInput(autofocus type="text" v-model="memberID" :placeholder="$t('ui.member')" size="sm")
              .form-group.col-12.mb-1
                SubmitButton(
                  icon="fa fa-search"
                  :loading="loading"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getTicketList()"
                  variant="primary"
                  size="sm"
                )

          .card-body
            .row
              .col-12
                ul#tickettab.nav.nav-tabs(role='tablist')
                  li.nav-item
                    a#deposit-tab.nav-link.active(data-toggle='tab' href='#deposit-content' role='tab' aria-controls='deposit' aria-selected='false')
                      span {{ $t("ui.deposit") }}
                      b-badge.ticket-total-badge(variant="danger" size="sm").ml-1 {{ depTotalRow }}
                  li.nav-item
                    a#withdrawal-tab.nav-link(data-toggle='tab' href='#withdrawal-content' role='tab' aria-controls='withdrawal' aria-selected='false')
                      span {{ $t("ui.withdrawal") }}
                      b-badge.ticket-total-badge(variant="danger" size="sm").ml-1 {{ wdwTotalRow }}
                  li.nav-item
                    a#review-tab.nav-link(data-toggle='tab' href='#review-content' role='tab' aria-controls='review' aria-selected='false')
                      span {{ $t("ui.dd_review") }}
                      b-badge.ticket-total-badge(variant="danger" size="sm").ml-1 {{ revTotalRow }}

                #tickettabcontent.tab-content.tab-bordered
                  #deposit-content.tab-pane.active.show(role='tabpanel' aria-labelledby='deposit-tab')
                    .row
                      .col-10.mb-1
                        b-pagination.float-left(
                          size="sm"
                          hide-ellipsis
                          :total-rows="depTotalRow"
                          :per-page="getPageSize"
                          v-model="currentDepPage"
                          @input="changedDepPage($event)").mb-1
                      .col-2.mb-1
                        b-input-group(:prepend="$t('ui.page_size')" size="sm")
                          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedDepPageSize" size="sm")
                      .col-12
                        .clusterize-scroll.table-responsive
                          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                            thead.thead-light
                              tr
                                th.text-center(width="3%")
                                  span #
                                th(width="5%")
                                  span(:title="$t('ui.id')") {{ $t('ui.id') }}
                                th(width="5%")
                                  span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
                                th(width="8%")
                                  span(:title="$t('ui.member')") {{ $t('ui.member') }}
                                th(width="5%")
                                  span(:title="$tc('ui.banks', 1)") {{ $tc('ui.banks', 1) }}
                                th(width="8%")
                                  span(:title="$t('ui.bank_acc_no')") {{ $t('ui.bank_acc_no') }}
                                th(width="8%")
                                  span(:title="$t('ui.bank_acc_holder')") {{ $t('ui.bank_acc_holder') }}
                                th(width="5%")
                                  span(:title="$t('ui.mode')") {{ $t('ui.mode') }}
                                th.text-right(width="8%")
                                  span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                                th(width="6%")
                                  span(:title="$t('ui.promo')") {{ $t("ui.promo") }}
                                th.text-right(width="6%")
                                  span(:title="$t('ui.bonus_amount')") {{ $t("ui.bonus_amount") }}
                                th(width="6%")
                                  span(:title="$t('ui.upline')") {{ $t("ui.upline") }}
                                th(width="6%")
                                  span(:title="$t('ui.vip')") {{ $t("ui.vip") }}
                                th.text-center(width="11%")
                                  span(:title="$t('ui.action')") {{ $t("ui.action") }}
                                th.text-right(width="10%")
                                  span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                            tbody.clusterize-content
                              tr(v-if="depositList.length == 0")
                                td(:colspan="15").text-center
                                  span {{ $t('message.no_data_available') }}
                              tr(v-for="(item, index) in depositList" :class="$helpers.rowClassTicket(item, 'deposit')")
                                td.text-center
                                  span(:title="((currentDepPage - 1) * getPageSize + index + 1)") {{ ((currentDepPage - 1) * getPageSize + index + 1) }}
                                td
                                  span.d-block(:title="item.id") {{ item.id }}
                                  span.small.text-info.d-block(:title="getRefNo(item.target_bank_id, item.id, item.prefix_d, item.prefix_delimiter)") {{ getRefNo(item.target_bank_id, item.id, item.prefix_d, item.prefix_delimiter) }}
                                td
                                  span(:title="item.parent_id") {{ item.parent_id }}
                                td
                                  span.font-weight-bold(:title="item.member_id")
                                    b-link.clickable(href="javascript:void(0);" @click="onInfo(item)") {{ item.member_id }}
                                td
                                  span(:title="item.target_bank_id") {{ item.target_bank_id }}
                                td
                                  span(:title="item.target_bank_acc_no") {{ item.target_bank_acc_no }}
                                td
                                  span(:title="item.target_bank_acc_holder") {{ item.target_bank_acc_holder }}
                                td
                                  span(:title="item.deposit_method") {{ item.deposit_method }}
                                td.text-right
                                  span.font-weight-bold.d-block(:title="$n(item.amount, 'currency')" :class="$helpers.fontClassName(item.amount)") {{ $n(item.amount, 'currency') }}
                                td
                                  span(:title="item.promotion_id") {{ item.promotion_id }}
                                td.text-right
                                  span.font-weight-bold.d-block(:title="$n(item.bonus_amount, 'currency')" :class="$helpers.fontClassName(item.bonus_amount)") {{ $n(item.bonus_amount, 'currency') }}
                                td
                                  span(:title="item.referrer_id") {{ item.referrer_id }}
                                td
                                  span(:title="item.vip_name") {{ item.vip_name }}
                                td.text-center
                                  template(v-if="isEditAccess")
                                    span(v-if="item.status.trim().toUpperCase() != 'PENDING'")
                                      a.fa.fa-search.btn.btn-ssm.btn-info(href="javascript:void(0)" @click="getTicketDetail(item, $event)" :title="$t('ui.view')")
                                    span.ml-1(v-if="item.attachment_path")
                                      a.fa.fa-paperclip.btn.btn-ssm.btn-icon.btn-warning(href="javascript:void(0)" @click="openAttachment(item)" :title="$t('ui.attachment')")
                                    span.ml-1(v-if="item.status.trim().toUpperCase() == 'PENDING'")
                                      a.fa.fa-check.btn.btn-ssm.btn-icon.btn-primary(href="javascript:void(0)" @click="approveTicket(item, $event)" :title="$t('ui.approve')")
                                    span.ml-1(v-if="item.status.trim().toUpperCase() == 'PENDING'")
                                      a.fa.fa-ban.btn.btn-ssm.btn-icon.btn-danger(href="javascript:void(0)" @click="rejectTicket(item, $event)" :title="$t('ui.reject')")
                                td.text-right
                                  span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}

                  #withdrawal-content.tab-pane(role='tabpanel' aria-labelledby='withdrawal-tab')
                    .row
                      .col-10.mb-1
                        b-pagination.float-left(
                          size="sm"
                          hide-ellipsis
                          :total-rows="wdwTotalRow"
                          :per-page="getPageSize"
                          v-model="currentWdwPage"
                          @input="changedWdwPage($event)").mb-1
                      .col-2.mb-1
                        b-input-group(:prepend="$t('ui.page_size')" size="sm")
                          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedWdwPageSize" size="sm")
                      .col-12
                        .clusterize-scroll.table-responsive
                          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                            thead.thead-light
                              tr
                                th.text-center(width="3%")
                                  span #
                                th(width="3%")
                                  span(:title="$t('ui.id')") {{ $t('ui.id') }}
                                th(width="7%")
                                  span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
                                th(width="3%")
                                  span(:title="$t('ui.member')") {{ $t('ui.member') }}
                                th.text-right(width="7%")
                                  span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                                th(width="17%")
                                  span(:title="$t('ui.receiver_bank')") {{ $t("ui.receiver_bank") }}
                                th(width="6%")
                                  span(:title="$t('ui.upline')") {{ $t("ui.upline") }}
                                th(width="6%")
                                  span(:title="$t('ui.vip')") {{ $t("ui.vip") }}
                                th.text-center(width="7%")
                                  span(:title="$t('ui.taken')") {{ $t("ui.taken") }}
                                th.text-center(width="8%")
                                  span(:title="$t('ui.action')") {{ $t("ui.action") }}
                                th.text-right(width="10%")
                                  span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                            tbody.clusterize-content
                              tr(v-if="withdrawalList.length == 0")
                                td(:colspan="11").text-center
                                  span {{ $t('message.no_data_available') }}
                              template(v-for="(item, index) in withdrawalList")
                                tr(:class="$helpers.rowClassTicket(item, 'withdrawal')")
                                  td.text-center
                                    span(:title="((currentWdwPage - 1) * getPageSize + index + 1)") {{ ((currentWdwPage - 1) * getPageSize + index + 1) }}
                                  td
                                    span(:title="item.id") {{ item.id }}
                                  td
                                    span(:title="item.parent_id") {{ item.parent_id }}
                                  td
                                    span.font-weight-bold(:title="item.member_id")
                                      b-link.clickable(href="javascript:void(0);" @click="onInfo(item)") {{ item.member_id }}
                                  td.text-right
                                    span.font-weight-bold.d-block(:title="$n(item.amount, 'currency')" :class="$helpers.fontClassName(item.amount)") {{ $n(item.amount, 'currency') }}
                                    //- a.fa.fa-info.btn.btn-ssm.btn-info.px-2(v-if="item.exchange_currency != null" href="javascript:void(0)" @click="getExchangeCurrencyTicketDetail(item)" :title="$t('ui.view')")
                                  td
                                    span(:title="item.target_bank_id") {{ item.target_bank_id }}
                                    br
                                    span(:title="item.target_bank_acc_no") {{ item.target_bank_acc_no }}
                                    br
                                    span(:title="item.target_bank_acc_holder") {{ item.target_bank_acc_holder }}
                                    template(v-if="['ARS','AUD'].includes(getCurrencyCode)")
                                      br
                                      span(:title="item.target_bank_acc_remark") {{ item.target_bank_acc_remark }}
                                    template(v-if="['AUD'].includes(getCurrencyCode)")
                                      br
                                      span(:title="item.target_bank_acc_remark_2") {{ item.target_bank_acc_remark_2 }}
                                  td
                                    span(:title="item.referrer_id") {{ item.referrer_id }}
                                  td
                                    span(:title="item.vip_name") {{ item.vip_name }}
                                  td
                                    div.d-flex.justify-content-center.align-items-center
                                      label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                                        input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="item.taken_by" :disabled="checkTaker(item)" @change="isEditAccess ? changedStatus(item, $event) : null")
                                        span.custom-switch-indicator(:title="showLabel(item, 'taken')")
                                  td.text-center
                                    template(v-if="isEditAccess")
                                      span
                                        a.fas.fa-poll.btn.btn-ssm.btn-success(href="javascript:void(0)" @click="onGetRecentDeposit(item)" :title="$t('ui.get_recent_deposit')")
                                      span.ml-1(v-if="item.status.trim().toUpperCase() != 'PENDING'")
                                        a.fa.fa-search.btn.btn-ssm.btn-info(href="javascript:void(0)" @click="getTicketDetail(item)" :title="$t('ui.view')")
                                      span.ml-1(v-if="item.status.trim().toUpperCase() == 'PENDING'")
                                        a.fa.fa-eye.btn.btn-ssm.btn-info(href="javascript:void(0)" @click="reviewTicket(item, $event)" :title="$t('ui.dd_review')")
                                      span.ml-1(v-if="item.status.trim().toUpperCase() == 'PENDING'")
                                        a.fa.fa-check-double.btn.btn-ssm.btn-warning(href="javascript:void(0)" @click="directAuditTicket(item, $event)" :title="$t('ui.audit')")
                                      span.ml-1(v-if="item.status.trim().toUpperCase() == 'PENDING'")
                                        a.fa.fa-ban.btn.btn-ssm.btn-danger(href="javascript:void(0)" @click="rejectTicket(item, $event)" :title="$t('ui.reject')")
                                  td.text-right
                                    span(v-if="item.created_date" :title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}

                  #review-content.tab-pane(role='tabpanel' aria-labelledby='review-tab')
                    .row
                      .col-10.mb-1
                        b-pagination.float-left(
                          size="sm"
                          hide-ellipsis
                          :total-rows="revTotalRow"
                          :per-page="getPageSize"
                          v-model="currentRevPage"
                          @input="currentRevPage($event)").mb-1
                      .col-2.mb-1
                        b-input-group(:prepend="$t('ui.page_size')" size="sm")
                          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedRevPageSize" size="sm")
                      .col-12
                        .clusterize-scroll.table-responsive
                          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                            thead.thead-light
                              tr
                                th.text-center(width="3%")
                                  span #
                                th(width="5%")
                                  span(:title="$t('ui.id')") {{ $t('ui.id') }}
                                th(width="8%")
                                  span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
                                th(width="8%")
                                  span(:title="$t('ui.member')") {{ $t('ui.member') }}
                                th.text-right(width="7%")
                                  span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                                th(width="17%")
                                  span(:title="$t('ui.receiver_bank')") {{ $t("ui.receiver_bank") }}
                                th.text-center(width="6%")
                                  span(:title="$t('ui.status')") {{ $t("ui.status") }}
                                //- th(width="6%")
                                //-   span(:title="$t('ui.rollback_count')") {{ $t("ui.rollback_count") }}
                                //- th(width="6%")
                                //-   span(:title="$t('ui.rejected_ticket_id')") {{ $t("ui.rejected_ticket_id") }}
                                th.text-center(width="8%")
                                  span(:title="$t('ui.action')") {{ $t("ui.action") }}
                                th.text-right(width="10%")
                                  span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                            tbody.clusterize-content
                              tr(v-if="reviewList.length == 0")
                                td(:colspan="9").text-center
                                  span {{ $t('message.no_data_available') }}
                              tr(v-for="(item, index) in reviewList" :class="$helpers.rowClassTicket(item, 'withdrawal')")
                                td.text-center
                                  span(:title="((currentRevPage - 1) * getPageSize + index + 1)") {{ ((currentRevPage - 1) * getPageSize + index + 1) }}
                                td
                                  span(:title="item.id") {{ item.id }}
                                td
                                  span(:title="item.parent_id") {{ item.parent_id }}
                                td
                                  span.font-weight-bold(:title="item.member_id")
                                    b-link.clickable(href="javascript:void(0);" @click="onInfo(item)") {{ item.member_id }}
                                td.text-right
                                  span.font-weight-bold.d-block(:title="$n(item.amount, 'currency')" :class="$helpers.fontClassName(item.amount)") {{ $n(item.amount, 'currency') }}
                                td
                                  span(:title="item.target_bank_id") {{ item.target_bank_id }}
                                  br
                                  span(:title="item.target_bank_acc_no") {{ item.target_bank_acc_no }}
                                  br
                                  span(:title="item.target_bank_acc_holder") {{ item.target_bank_acc_holder }}
                                  template(v-if="['ARS','AUD'].includes(getCurrencyCode)")
                                    br
                                    span(:title="item.target_bank_acc_remark") {{ item.target_bank_acc_remark }}
                                  template(v-if="['AUD'].includes(getCurrencyCode)")
                                    br
                                    span(:title="item.target_bank_acc_remark_2") {{ item.target_bank_acc_remark_2 }}
                                td.text-center
                                  span(v-if="item.status.trim().toUpperCase() == 'REVIEW'" :class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
                                //- td
                                //-   span.font-weight-bold(:title="$n(item.rollback_count, 'integer')" v-if="item.rollback_count")
                                //-     b-link.clickable(href="javascript:void(0);" @click="onGetRollbackDetail(item)") {{ $n(item.rollback_count, 'integer') }}
                                //-   span(v-else) {{ item.rollback_count }}
                                //- td
                                //-   span.font-weight-bold(:title="item.rejected_ticket_id" v-if="item.rejected_ticket_id")
                                //-     b-link.clickable(href="javascript:void(0);" @click="onGetRejectDetail(item)") {{ item.rejected_ticket_id }}
                                //-   span(v-else) {{ item.rejected_ticket_id }}
                                td.text-center
                                  template(v-if="isEditAccess")
                                    span
                                      a.fa.fa-search.btn.btn-ssm.btn-primary(href="javascript:void(0)" @click="getTicketDetail(item)" :title="$t('ui.view')")
                                    span.ml-1
                                      a.fa.fa-check-double.btn.btn-ssm.btn-warning(href="javascript:void(0)" @click="auditTicket(item, $event)" :title="$t('ui.audit')")
                                    //- span
                                    //-   a.fa.fa-check.text-secondary(href="javascript:void(0)" @click="approveTicket(item, $event)" :title="$t('ui.approve')")
                                    //- span
                                    //-   a.fas.fa-check-circle.text-success(href="javascript:void(0)" @click="manualApproveTicket(item, $event)" :title="$t('ui.manual_approve')")
                                    span.ml-1
                                      a.fa.fa-ban.btn.btn-ssm.btn-danger(href="javascript:void(0)" @click="rejectTicket(item, $event)" :title="$t('ui.reject')")
                                td.text-right
                                  span(v-if="item.created_date" :title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}



    ticketdetail(ref="ticketdetail" :ticketId="selectedTicketId" @failed="handleFailed")
    approveticket(ref="approveticket" :ticketId="selectedTicketId" :parentId="selectedParentId" :memberId="selectedMemberId" @clicked="afterEditTicket" @failed="handleFailed")
    rejectticket(ref="rejectticket" :ticketId="selectedTicketId" @clicked="afterEditTicket" @failed="handleFailed")
    reviewticket(ref="reviewticket" :ticketId="selectedTicketId" :memberId="selectedMemberId" @clicked="afterReviewTicket" @failed="handleFailed")
    getrecentdeposit(ref="getrecentdeposit" :item="editSelectedMember" @failed="handleFailed")
    directauditticket(ref="directauditticket" :ticketId="selectedTicketId" :parentId="selectedParentId" :memberId="selectedMemberId" @clicked="afterDirectAuditTicket" @failed="handleFailed")
    manualapproveticket(ref="manualapproveticket" :ticketId="selectedTicketId" :parentId="selectedParentId" :memberId="selectedMemberId" @clicked="afterEditTicket" @failed="handleFailed")
    getrollbackdetail(ref="getrollbackdetail" :item="selectedTicket" @failed="handleFailed")
    getrejectdetail(ref="getrejectdetail" :item="selectedTicket" @failed="handleFailed")
    auditticket(ref="auditticket" :ticketId="selectedTicketId" :memberId="selectedMemberId" @clicked="afterAuditTicket" @failed="handleFailed")
    exchangecurrencyticketdetail(ref="exchangecurrencyticketdetail" :ticketId="selectedTicketId" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import ticketdetail from "@/components/ticket/ticketDetail.vue";
import approveticket from "@/components/ticket/approveTicket.vue";
import rejectticket from "@/components/ticket/rejectTicket.vue";
import reviewticket from "@/components/ticket/reviewTicket.vue";
import getrecentdeposit from "@/components/ticket/getRecentDeposit.vue";
import directauditticket from "@/components/ticket/directAuditTicket.vue";
import manualapproveticket from "@/components/ticket/manualApproveTicket.vue";
import getrollbackdetail from "@/components/ticket/getRollbackDetail.vue";
import getrejectdetail from "@/components/ticket/getRejectDetail.vue";
import auditticket from "@/components/ticket/auditTicket.vue"
import exchangecurrencyticketdetail from "@/components/ticket/exchangeCurrencyTicketDetail.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ticketdetail,
    approveticket,
    rejectticket,
    reviewticket,
    getrecentdeposit,
    directauditticket,
    manualapproveticket,
    getrollbackdetail,
    getrejectdetail,
    auditticket,
    exchangecurrencyticketdetail
  },
  data: () => ({
    loading: false,
    depositList: [],
    withdrawalList: [],
    reviewList: [],
    currentDepPage: 1,
    currentWdwPage: 1,
    currentRevPage: 1,
    depTotalRow: 0,
    wdwTotalRow: 0,
    revTotalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    requestType: null,
    ticketTimer: null,
    refreshInterval: 5,
    refreshChange: "",
    selectedTicketId: null,
    selectedTicket: null,
    selectedParentId: null,
    selectedMemberId: null,
    al: null,
    search: '',
    editSelectedMember: null,
    step: 0,
    ticketId: "",
    searchType: "ticket",
    operatorID: "",
    memberID: ""
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    alert:
    {
      get() {
        return this.$store.getters.alertOn;
      },
      set(value) {
        this.changedAlertOn(value);
      }
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId
    },
    loginId() {
      return this.$store.getters.loginId;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_pendingticket");
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
  },
  created: function() {
    this.$options.refreshOn = false;
  },
  mounted: function() {
    if (this.$store.getters.pendingTicket.tab != null && this.$store.getters.pendingTicket.tab != '') {
      this.step = this.$store.getters.pendingTicket.tab;
    }
    this.getTicketList();
  },
  destroyed: function() {
    this.$store.dispatch("user/setSelectedMemberID", null);

    if (this.ticketTimer) {
      clearTimeout(this.ticketTimer);
    } 
    var json = {
      tab: null
    };
    this.$store.dispatch("user/setPendingTicketParam", json);
  },
  methods: {
    showLabel(item, mode) {
      if(mode == 'label') {
        return this.$t('ui.ignore_risk') + ': ' + item.d + '\n' + this.$t('ui.permitted_amount') + ': ' + item.e
      }

      if(mode == 'taken') {
        return item.taken_by + '\n' + item.taken_date
      }
      return null
    },
    checkTaker(e) {
      // Get the original taken_by value (before v-model converts it to boolean)
      // If taken_by is a boolean, it means v-model has modified it, so we need to check taken_by_original
      // Otherwise, use taken_by directly (it's still the original string value from API)
      let takenBy;
      if (typeof e.taken_by === 'boolean') {
        // v-model has converted it to boolean, use original value if available
        takenBy = (e.taken_by_original !== undefined && e.taken_by_original !== null) 
          ? e.taken_by_original 
          : null;
      } else {
        // Still the original value from API (string or null)
        takenBy = e.taken_by;
      }
      
      // Enable (return false) when both taken_by and taken_date are null or empty
      if (!takenBy && !e.taken_date) return false;

      // Enable (return false) when loginId matches taken_by
      // Disable (return true) when loginId does not match taken_by
      return String(this.loginId) !== String(takenBy);
    },
    changedStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.ticket_taken_confirm", { name: item.id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.taken_by;
            item.taken_by = !item.taken_by;
          }
        });
    },
    confirmStatus: function(item, status) {
      let url = status ? config.ticketTakenMarkUrl() : config.ticketTakenUnmarkUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        ticket_id: item.id
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getTicketList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.getTicketList();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getTextColor(backgroundColor) {
      if (!backgroundColor) return '#000000'; // Default to black if no color provided
      // Convert hex color to RGB
      const rgb = backgroundColor.replace('#', '').match(/.{1,2}/g).map((hex) => parseInt(hex, 16));
      // Calculate relative luminance
      const luminance = (0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2]) / 255;
      return luminance > 0.5 ? '#000000' : '#ffffff'; // Black for light backgrounds, white for dark
    },
    resetInput() {
      this.operatorID = "";
      this.memberID = "";
      this.ticketId = "";
    },
    getRefNo: function(bank_id, id, prefix, delimiter) {
      return this.$helpers.getPaymentGatewayRefNoSetMember(bank_id, id, prefix, delimiter);
    },
    changedAlertOn: function(eventStatus) {
      this.$store.dispatch("user/setAlertOn", eventStatus);
    },
    onGetRecentDeposit(e) {
      this.editSelectedMember = e;
      this.$refs.getrecentdeposit.$refs.getRecentDeposit.show();
    },
    getTicketList() {
      this.getDepositList(true);
      this.getWithdrawalList(true);
      this.getReviewList(true);
    },
    openAttachment(obj) {
      this.$store.dispatch("user/setAttachmentPath", obj.attachment_path);
      let routeData = this.$router.resolve({path: '/attachment'});
      window.open(routeData.href, '_blank', "toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=250,width=1500,height=800");
    },
    getDepositList: function(isSearch) {
      let url = config.ticketListPendingUrl();

      if (isSearch) this.currentDepPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        request_type: 'DEPOSIT',
        page_number: this.currentDepPage,
        page_size: this.getPageSize
      };

      if(this.searchType == 'operator' || this.searchType == 'member') {
        json.operator_id = this.operatorID
        json.member_id = this.memberID
      } else {
        json.ticket_id = this.ticketId ? this.$helpers.getTicketId(this.ticketId) : null
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.depositList = response.data.dt;
                this.depTotalRow = this.depositList.length > 0 ? this.depositList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getWithdrawalList: function(isSearch) {
      let url = config.ticketListPendingUrl();

      if (isSearch) this.currentWdwPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        request_type: 'WITHDRAWAL',
        page_number: this.currentWdwPage,
        page_size: this.getPageSize
      };

      if(this.searchType == 'operator' || this.searchType == 'member') {
        json.operator_id = this.operatorID
        json.member_id = this.memberID
      } else {
        json.ticket_id = this.ticketId ? this.$helpers.getTicketId(this.ticketId) : null
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.withdrawalList = response.data.dt.map(item => {
                  // Preserve original taken_by value for comparison
                  item.taken_by_original = item.taken_by;
                  // Convert to boolean for checkbox v-model
                  item.taken_by = !!item.taken_by;
                  return item;
                });
                this.wdwTotalRow = this.withdrawalList.length > 0 ? this.withdrawalList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getReviewList: function(isSearch) {
      let url = config.ticketListReviewAuditUrl();

      if (isSearch) this.currentRevPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        request_type: 'WITHDRAWAL',
        ticket_status: "REVIEW",
        page_number: this.currentRevPage,
        page_size: this.getPageSize,
      };

      if(this.searchType == 'operator' || this.searchType == 'member') {
        json.operator_id = this.operatorID
        json.member_id = this.memberID
      } else {
        json.ticket_id = this.ticketId ? this.$helpers.getTicketId(this.ticketId) : null
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.reviewList = response.data.dt;
                this.revTotalRow = this.reviewList.length > 0 ? this.reviewList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getTicketDetail: function(e) {
      this.selectedTicketId = e.id;
      this.$refs.ticketdetail.$refs.ticketDetail.show();
    },
    getExchangeCurrencyTicketDetail: function(e) {
      this.selectedTicketId = e.id;
      this.$refs.exchangecurrencyticketdetail.$refs.exchangeCurrencyTicketDetail.show();
    },
    onGetRollbackDetail(e) {
      this.selectedTicket = e;
      this.$refs.getrollbackdetail.$refs.getRollbackDetail.show();
    },
    onGetRejectDetail(e) {
      this.selectedTicket = e;
      this.$refs.getrejectdetail.$refs.getRejectDetail.show();
    },
    afterEditTicket: function(type, afterBalance) {
      this.getTicketList();

      if (type == 1) {
        this.$swal({
          title: this.$t("ui.combine.edit_ticket"),
          html:
            "<div>" +
            this.$t("ui.after_balance") +
            ": <strong>" +
            this.$n(afterBalance, 'currency') +
            "</strong></div>",
          type: "success",
          confirmButtonText: this.$t("ui.ok"),
          allowOutsideClick: false
        }).then(isConfirm => {
          if (isConfirm.value) {

          }
        });
      } else
        this.$helpers.showDialog(this.$t("ui.combine.edit_ticket"), this.$t("message.success"), "success");
    },
    afterReviewTicket: function() {
      this.getTicketList();
      this.$helpers.showDialog(this.$t("ui.combine.review_ticket"), this.$t("message.success"), "success");
    },
    afterAuditTicket: function() {
      this.getTicketList();
      this.$helpers.showDialog(this.$t("ui.combine.audit_ticket"), this.$t("message.success"), "success");
    },
    afterDirectAuditTicket: function() {
      this.getTicketList();
      this.$helpers.showDialog(this.$t("ui.combine.direct_audit_ticket"), this.$t("message.success"), "success");
    },
    approveTicket: function(e) {
      this.selectedTicketId = e.id;
      this.selectedParentId = e.parent_id;
      this.selectedMemberId = e.member_id;
      this.$refs.approveticket.$refs.approveTicket.show();
    },
    reviewTicket: function(e) {
      this.selectedTicketId = e.id;
      this.selectedMemberId = e.member_id;
      this.$refs.reviewticket.$refs.reviewTicket.show();
    },
    rejectTicket: function(e) {
      this.selectedTicketId = e.id;
      this.$refs.rejectticket.$refs.rejectTicket.show();
    },
    directAuditTicket: function(e) {
      this.selectedTicketId = e.id;
      this.selectedParentId = e.parent_id;
      this.selectedMemberId = e.member_id;
      this.$refs.directauditticket.$refs.directAuditTicket.show();
    },
    auditTicket: function(e) {
      this.selectedTicketId = e.id;
      this.selectedMemberId = e.member_id;
      this.$refs.auditticket.$refs.auditTicket.show();
    },
    onInfo(e) {
      this.$store.dispatch("user/setSelectedOperatorID", e.parent_id);
      this.$store.dispatch("user/setSelectedMemberID", e.member_id);
      window.open(window.location.origin + "/account/settings", '_blank');
    },
    manualApproveTicket: function(e) {
      this.selectedTicketId = e.id;
      this.selectedParentId = e.parent_id;
      this.selectedMemberId = e.member_id;
      this.$refs.manualapproveticket.$refs.manualApproveTicket.show();
    },
    toggleRefresh: function() {
      this.startRefreshTimer();
    },
    startRefreshTimer: function() {
      if (this.ticketTimer) {
        clearTimeout(this.ticketTimer);
      }
      if (this.$options.refreshOn) {
        this.getTicketList();
        this.ticketTimer = setTimeout(() => {
          this.startRefreshTimer();
        }, this.refreshInterval * 1000);
      } else {
        this.refreshChange = "STOPPED";
      }
    },
    changedDepPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentDepPage = 1;
      this.getDepositList(true);
    },
    changedDepPage: function(pageNo) {
      this.currentDepPage = pageNo;
      this.getDepositList();
    },
    changedWdwPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentWdwPage = 1;
      this.getWithdrawalList(true);
    },
    changedWdwPage: function(pageNo) {
      this.currentWdwPage = pageNo;
      this.getWithdrawalList();
    },
    changedRevPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentRevPage = 1;
      this.getReviewList(true);
    },
    changedRevPage: function(pageNo) {
      this.currentRevPage = pageNo;
      this.getReviewList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>